export default "__VITE_ASSET__DPbF4HH6__"